import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

class ConfigureRewards extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		showUpdateModal: false,
    		data: {
    			rewardDetails: [],
    			editStatus: false
    		},
    		editData: {
    			rewardId: '',
    			rewardName: '',
    			rewardPoint: ''
    		}
    	}
    }

    fetchRewards = () => {
    	let data = Object.assign({}, this.state.data)
    	let fetchRewardTypes = 'reward_type'

    	return api.getAdminResponse(this.props.user.accessToken, fetchRewardTypes)
    	.then((result) => {
    		if(result.status === 'success'){
    			data.rewardDetails = result.data
    			this.setState({data: data, showUpdateModal: false})
    		}
    	})
    }

    componentDidMount() {
    	this.fetchRewards()
    }

    disableActivity = (e, rewardId, rewardStatus) => {
    	let changeStatus
    	if (rewardStatus === 'Active') {
    		changeStatus = false
    	}
    	else {
    		changeStatus = true
    	}

    	let values = {
    		'id': rewardId,
    		'active': changeStatus
    	}

    	api.patchRewardTypes(this.props.user.accessToken, values)
    	.then((result) => {
    		if (result.status === 'success'){
    			this.fetchRewards()
    		}
    	})
    }

    handleshowUpdateModal = (e, rewardId, rewardName, rewardPoint) => {
    	let editData = Object.assign({}, this.state.editData)
    	editData.rewardId = rewardId
    	editData.rewardName = rewardName
    	editData.rewardPoint = rewardPoint
    	this.setState({editData: editData, showUpdateModal: true})
    }

    handlePointChange = (e) => {
    	let editData = Object.assign({}, this.state.editData)
    	editData.rewardPoint = e.target.value
    	this.setState({editData: editData})
    }

    updatePoints = (e) => {
    	let values = {
    		'id': this.state.editData.rewardId,
    		'points': this.state.editData.rewardPoint
    	}

    	api.patchRewardTypes(this.props.user.accessToken, values)
    	.then((result) => {
    		if (result.status === 'success'){
    			this.fetchRewards()
    		}
    	})
    }

    render(){
    	const { showUpdateModal } = this.state;
    	let disableActivity = this.disableActivity
    	let updatePoints = this.updatePoints
    	let handleshowUpdateModal = this.handleshowUpdateModal

    	let editModal=(
			<Dialog
				open={showUpdateModal}
				onClose={evt => this.setState({showUpdateModal: false})} >
				<DialogSurface>
					<DialogHeader>
						<DialogHeaderTitle>Edit Reward Points</DialogHeaderTitle>
					</DialogHeader>
					<DialogBody>
						<Typography className="add-opportunity"> {this.state.editData.rewardName} </Typography>
						<Grid className = "opportunity-list-item">
							<GridCell span = "6">
								<TextField className='admin-reg-filter-criteria' fullwidth label ="Point"  autoComplete="off"  name="name" value = {this.state.editData.rewardPoint} onChange = {this.handlePointChange} style={{ height: '140%' }}/>
							</GridCell>
						</Grid>
					</DialogBody>
					<DialogFooter>
						<DialogFooterButton cancel>Close</DialogFooterButton>
						<DialogFooterButton onClick = {((e) => updatePoints(e))}>Save</DialogFooterButton>
					</DialogFooter>
				</DialogSurface>
				<DialogBackdrop />  
			</Dialog>
		)

    	let tableComponent = (
			<tbody>
	            {this.state.data.rewardDetails.map(function(reward){
	            	let rewardId = reward.id
	            	let rewardStatus = reward.active
	            	if (reward.active === 'Active') {
		            	return(
		            		<tr key = {reward.id}>
		            			<td>{reward.id}</td>
		            			<td>{reward.name}</td>
		            			<td>{reward.points}</td>
		            			<td>{reward.active}</td>
		            			<td>
		            				<Button disabled raised style={{ width: '40%' }}>Edit</Button>
	                    			<Button style={{ width: '40%' }} onClick = {((e) => disableActivity(e, rewardId, rewardStatus))}>Disable</Button>
		            			</td>
		            		</tr>
		            	)
		            }
		            else {
		            	return(
		            		<tr key = {reward.id}>
		            			<td>{reward.id}</td>
		            			<td>{reward.name}</td>
		            			<td>{reward.points}</td>
		            			<td>{reward.active}</td>
		            			<td>
		            				<Button raised style={{ width: '40%' }} onClick={((e) => handleshowUpdateModal(e, reward.id, reward.name, reward.point))}>Edit</Button>
	                    			<Button style={{ width: '40%' }} onClick = {((e) => disableActivity(e, rewardId, rewardStatus))}>Enable</Button>
		            			</td>
		            		</tr>
		            	)
		            }
	            })}
	        </tbody>
	    )
    	return(
	    	<div>
		    	<div className="mdc-layout-grid">
			    	<Grid>
		        		<GridCell span="12">
		        			<table>
		        				<th>S.No</th>
					            <th>Reward Activity</th>
					            <th>Points</th>
					            <th>Status</th>
					            <th>Action</th>
					            {tableComponent}
					            {editModal}
		        			</table>
		        		</GridCell>
		      		</Grid>
		      	</div>
	      	</div>
	    )
    }
}

function mapStateToProps({user, admin}) {
	return {
		user,
		admin
	}
}

function mapDispatchToProps() {
  	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureRewards);


// WEBPACK FOOTER //
// ./src/views/rewards_admin/ConfigureRewards.jsx